import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const Footer: React.FC = () => {
  const { t } = useTranslation();
  return (
    <footer className="bg-dark text-white">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <div>
            <h3 className="text-xl font-bold mb-4">{t('footer.organization')}</h3>
            <p className="text-gray-300 mb-4">
              {t('footer.tagline')}
            </p>
            <div className="flex space-x-4">
              <a href="https://www.instagram.com/paraclimbing.team.belgium" target="_blank" rel="noopener noreferrer" className="text-gray-300 hover:text-white">
                <svg className="h-6 w-6" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z" />
                </svg>
              </a>
            </div>
          </div>
          
          <div>
            <h3 className="text-xl font-bold mb-4">{t('footer.quickLinks')}</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-gray-300 hover:text-white">{t('navbar.home')}</Link>
              </li>
              <li>
                <Link to="/paraclimbing" className="text-gray-300 hover:text-white">{t('footer.aboutParaclimbing')}</Link>
              </li>
              <li>
                <Link to="/activities" className="text-gray-300 hover:text-white">{t('footer.activitiesEvents')}</Link>
              </li>
              <li>
                <Link to="/support-us" className="text-gray-300 hover:text-white">{t('footer.supportUs')}</Link>
              </li>
              <li>
                <Link to="/contact" className="text-gray-300 hover:text-white">{t('footer.contactUs')}</Link>
              </li>
            </ul>
          </div>
          
          <div>
            <h3 className="text-xl font-bold mb-4">{t('footer.contactInfo')}</h3>
            <p className="text-gray-300 mb-2">
              <span className="font-semibold">{t('footer.email')}:</span> info@paraclimbing.be
            </p>
            <p className="text-gray-300 mb-2">
              <span className="font-semibold">{t('footer.phone')}:</span> 0489410092
            </p>
            <p className="text-gray-300">
              <span className="font-semibold">{t('footer.address')}:</span><br />
              Parabel VZW<br />
              Valkerijgang 32<br />
              3000 Leuven, Belgium
            </p>
          </div>
        </div>
        
        <div className="border-t border-gray-700 mt-8 pt-8 text-center text-gray-300">
          <p>&copy; {new Date().getFullYear()} Paraclimbing.be. {t('footer.copyright')}</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
